import React from 'react';

export const NewsArticle = (props) => {
  return <div className="__news-article" {...props} />;
};
